export default function Director() {
  return (
    <section className="py-12 bg-orange-50">
      <div className="max-w-md mx-auto px-4">
        {/* セクションタイトル */}
        <h2 className="text-xl font-bold text-gray-800 text-center mb-1">院長紹介</h2>
        <p className="text-gray-500 text-sm text-center mb-8">施術者について</p>

        {/* 院長カード */}
        <div className="bg-white rounded-2xl overflow-hidden">
          {/* 写真エリア */}
          <div className="w-full h-72 overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/edited_926f0ac7ab222556aba681c3ebfe7b15_506ea238.jpg"
              alt="院長 佐川 英徳"
              className="w-full h-full object-cover object-[center_20%]"
            />
          </div>

          {/* テキストエリア */}
          <div className="p-6">
            {/* 院長名 */}
            <div className="mb-4">
              <p className="text-xs text-orange-500 font-semibold mb-1">院長</p>
              <h3 className="text-xl font-bold text-gray-800">佐川 英徳</h3>
              <p className="text-sm text-gray-500 mt-0.5">柔道整復師（国家資格）</p>
            </div>

            {/* 区切り線 */}
            <div className="border-t border-orange-100 mb-4"></div>

            {/* キャッチコピー */}
            <p className="text-base font-bold text-gray-800 mb-3 leading-snug">
              「産後の不調、我慢していませんか？」
            </p>

            <p className="text-sm text-gray-600 leading-relaxed mb-5">
              整体院・接骨院・リラクゼーションサロンで常に上位の実績を残してきました。
              臨床<strong className="text-gray-800">20年</strong>・年間<strong className="text-gray-800">12,000件以上</strong>の施術実績を持つ院長が、
              産後の骨盤の歪みを整え、トータルでサポートします。
            </p>

            {/* できること一覧 */}
            <div className="bg-orange-50 rounded-xl px-5 py-4 space-y-2">
              <p className="text-xs font-bold text-orange-500 mb-2 tracking-wide">サポートできること</p>
              {[
                '腰痛・肩こりの改善',
                'ぽっこりお腹・体型崩れのケア',
                '疲れにくい身体づくり',
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-2">
                  <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-orange-500 text-base"></i>
                  </span>
                  <p className="text-sm text-gray-700">{item}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
